export class Changeability {
    editable: boolean;
    dividable: boolean;
    isParent: boolean;
}
